namespace TabAurous.Retail {
    export interface GiftVoucherSalesDetailsRow {
        TransItemId?: number;
        TransId?: number;
        GvMasterId?: number;
        Code?: string;
        GvNumber?: string;
        Value?: number;
        Amount?: number;
        CompanyId?: number;
        EmployeeId?: number;
        UserId?: number;
        RefVoucherTypeId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
    }

    export namespace GiftVoucherSalesDetailsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'GvNumber';
        export const localTextPrefix = 'Retail.GiftVoucherSalesDetails';
        export const deletePermission = 'Retail:GiftVoucherSales:Delete';
        export const insertPermission = 'Retail:GiftVoucherSales:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:GiftVoucherSales:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            GvMasterId = "GvMasterId",
            Code = "Code",
            GvNumber = "GvNumber",
            Value = "Value",
            Amount = "Amount",
            CompanyId = "CompanyId",
            EmployeeId = "EmployeeId",
            UserId = "UserId",
            RefVoucherTypeId = "RefVoucherTypeId",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId"
        }
    }
}
